module.exports = __webpack_public_path__ + "fonts/Clash-Heavy.ee7cf27.woff";